'use client'

import React, { useState, useEffect, useRef } from "react";
import { useGlobalContext } from "../../context/provider";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPenToSquare } from "@fortawesome/free-solid-svg-icons";
import { useRouter } from "next/navigation";

import LogoLight from '@/public/EVElogo.webp'
import LogoDark from '@/public/EVElogoWhite.webp'
import Image from "next/image";
import UserMenu from "../../HeaderMenu/UserMenu";

import LoginModal from "../../Modal/LoginModal";
import Link from "next/link";
import NotiDesktop from "../Noti/NotiDesktop";

const HeaderDesktop = ({ noti, hasFreeCampaigns = false }) => {

    const { theme, setTheme, CartAction, setIsLoginModal, setTypeLogin, isLogin, DataUser } = useGlobalContext()
    const menuRef = useRef(null);

    const [menu, setMenu] = useState(false)
    const [isClient, setIsClient] = useState(false);
    const router = useRouter()

    useEffect(() => {
        setIsClient(true);
    }, []);

    const OnLogin = async () => {
        setTypeLogin('login')
        setIsLoginModal(true)
    }

    const wrapperRef = useRef(null); // ใช้ครอบปุ่ม + เมนู

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
                setMenu(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);


    return (
        <>
            <LoginModal />
            <div style={{ zIndex: '500' }} className="w-full h-[128px] fixed " />
            <div style={{ zIndex: '700' }} className="w-full h-[128px] flex flex-col justify-between  text-black  fixed items-center">
                <div className="px-[4%] lg:px-[6%] xl:px-[10%] h-[80px] page-bg flex justify-between items-center w-full">
                    <Link href="/" prefetch={true} className="cursor-pointer">
                        {theme === 'light_theme' ? <Image className="h-[48px] w-auto " src={LogoLight} width={100} height={100} alt="logo"></Image> : <Image className="h-[48px] w-auto " src={LogoDark} width={100} height={100} alt="logo"></Image>}
                    </Link>
                    <div ref={wrapperRef} className="flex items-center gap-[5px] md:gap-[16px]">
                        <button className="page-surface cursor-pointer w-[48px] h-[48px] rounded-full flex justify-center items-center text-primary" onClick={() => { router.push('/search') }}>
                            <svg
                                className="w-auto h-[24px]"
                                style={{ height: '24px', width: 'auto' }}
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M11.5 21C16.7467 21 21 16.7467 21 11.5C21 6.25329 16.7467 2 11.5 2C6.25329 2 2 6.25329 2 11.5C2 16.7467 6.25329 21 11.5 21Z"
                                    stroke="currentColor"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                                <path
                                    d="M22 22L20 20"
                                    stroke="currentColor"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                        </button>
                        <div className="text-primary">

                            <button className="page-surface cursor-pointer w-[48px] h-[48px] rounded-full flex justify-center items-center" onClick={() => { theme === 'light_theme' ? setTheme('dark_theme') : setTheme('light_theme') }}>
                                {theme === 'dark_theme' ?
                                    <img className="w-auto h-[24px]" style={{ height: '24px', width: 'auto' }} width={24} height={24} src="https://eve-image.eveebook.com/image.eveebook/web_image/sun.png" alt="theme" />
                                    :
                                    <img className="w-auto h-[24px]" style={{ height: '24px', width: 'auto' }} width={24} height={24} src="https://eve-image.eveebook.com/image.eveebook/web_image/moon.png" alt="theme" />
                                }
                            </button>
                        </div>
                        {(isLogin && DataUser) &&
                            <NotiDesktop noti={noti} />

                        }
                        <div className="flex  gap-[5px] md:gap-[32px]">
                            <button onClick={() => { router.push('/cart') }} className="w-[48px] cursor-pointer page-surface rounded-full h-[48px] flex items-center justify-center relative" >
                                {theme === 'light_theme' ?
                                    <img className="w-auto h-[24px]" style={{ height: '24px', width: 'auto' }} width={24} height={24} src="https://eve-image.eveebook.com/image.eveebook/web_image/cart.png" alt="cart" /> :
                                    <img className="w-auto h-[24px]" style={{ height: '24px', width: 'auto' }} width={24} height={24} src="https://eve-image.eveebook.com/image.eveebook/web_image/cart_w.png" alt="cart" />
                                }
                                <div className="absolute top-0 right-0">
                                    {isClient && CartAction && (<div className=" text-[10px] font-bold text-white flex justify-center items-center w-[17px] h-[17px] bg-[#E04C4C] rounded-full"><span>{CartAction.length}</span></div>)}
                                </div>
                            </button>
                            {!isLogin ? <button onClick={() => OnLogin()} className="btn-primary w-[118px] cursor-pointer rounded-[8px] h-[48px] ">เข้าสู่ระบบ</button> :
                                <button onClick={() => setMenu((prev) => !prev)} ><div className="h-[48px] cursor-pointer w-[48px] rounded-full"
                                    style={{
                                        backgroundImage: `url(${DataUser?.imge_profile_ebook}?t=${Date.now()})`,
                                        backgroundSize: 'cover',
                                        backgroundPosition: 'center',
                                    }}></div>
                                </button>}
                        </div>
                        <UserMenu menu={menu} setMenu={setMenu} />
                    </div>

                </div>
                <div className="px-2 lg:px-[3%] xl:px-[5%] text-[13px] xl:text-[14px] h-[48px] flex justify-between items-center w-full bg-dark-gradient text-white overflow-hidden">
                    <div className="flex items-center overflow-x-auto scrollbar-none whitespace-nowrap">
                        <Link prefetch={true} className="px-2 lg:px-3 xl:px-4 font-medium whitespace-nowrap hover:text-[#FF5C9F] transition-colors" href="/">หน้าแรก</Link>
                        <Link className="px-2 lg:px-3 xl:px-4 font-medium whitespace-nowrap hover:text-[#FF5C9F] transition-colors" href="/search">ค้นหาอีบุ๊ค</Link>
                        <Link className="px-2 lg:px-3 xl:px-4 font-medium whitespace-nowrap hover:text-[#FF5C9F] transition-colors" href="/promotion">โปรโมชั่น</Link>
                        {hasFreeCampaigns && <Link className="px-2 lg:px-3 xl:px-4 font-medium whitespace-nowrap hover:text-[#FF5C9F] transition-colors" href="/free-campaign">อ่านฟรี</Link>}
                        <Link className="px-2 lg:px-3 xl:px-4 font-medium whitespace-nowrap hover:text-[#FF5C9F] transition-colors" href="/preorder">⭐ พรีออเดอร์ ⭐</Link>
                        <Link className="px-2 lg:px-3 xl:px-4 font-medium whitespace-nowrap hover:text-[#FF5C9F] transition-colors" target="_blank" rel="noopener noreferrer" href="https://www.facebook.com/share/15wWnQqWGN/?mibextid=wwXIfr">ข่าวสาร</Link>
                        <Link className="px-2 lg:px-3 xl:px-4 font-medium whitespace-nowrap hover:text-[#FF5C9F] transition-colors" target="_blank" rel="noopener noreferrer"
                            href="https://play.google.com/store/apps/details?id=com.eve.ebook&pcampaignid=web_share"
                        >
                            <span className="hidden xl:inline">ดาวน์โหลดแอปพลิเคชั่น</span>
                            <span className="inline xl:hidden">ดาวน์โหลดแอป</span>
                        </Link>
                    </div>
                    <button className="flex-shrink-0 px-4 xl:px-10 h-full flex items-center justify-center bg-[#B8245A] hover:bg-[#a01f4e] transition-colors whitespace-nowrap">
                        <Link target="_blank" rel="noopener noreferrer" href="https://writer.eveebook.com/" className="flex items-center text-white whitespace-nowrap">
                            <FontAwesomeIcon
                                icon={faPenToSquare}
                                className="px-[6px]"
                                style={{ width: '18px', height: '18px' }}
                            />
                            <span>ลงขายผลงานของคุณ</span>
                        </Link>
                    </button>
                </div>
            </div>
        </>
    )
}

export default HeaderDesktop
